import React from 'react';
import { REACT_APP_API_BASE } from '../../config';
import './styles.scss';

const File = props => {

    if (!props.publication) return null;

    const downloadFile = async (e, doc)  => {
        e.preventDefault();
        const res = await props.fetch(`${REACT_APP_API_BASE}/online/publication/document/${doc.publicationFileId}`);
        
        if (res.ok) {
            const exportReport = await res.blob();
            var blob = new Blob([exportReport], { type: doc.contentType });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = doc.originalFileName
            link.click();
        }
    }

    const getExtension = file => {
        return file.substring(file.lastIndexOf('.')+1);
    };

    return (
        <div className="file">
            <div className="file__content">
                <div className="file__thumb">
                    <picture className="file__thumb-ratio">
                        {(props.publication.images && props.publication.images.length > 0) &&
                            <img src={props.publication.images[0].filePath} alt="" />
                        }
                    </picture>
                </div>

                <div className="file__text">
                    <h2 className="file__heading">{props.publication.fileTitle}</h2>
                    <div dangerouslySetInnerHTML={{ __html: props.publication.fileDescription }}></div>
                </div>
            </div>
            <div className="file__cta">
                {props.publication.userHasAccessToThisPublication && props.publication.files.map((file) => {
                    return (
                        <button type="button" key={`file${file.publicationFileId}`} onClick={(e) => downloadFile(e, file)} className="button file__download">Ladda ned {getExtension(file.fileName)}</button>
                    );
                })}

                {!props.publication.userHasAccessToThisPublication &&
                    <a href="https://www.delfi.se/publications" className="button file__download">Beställ publikation</a>
                }
            </div>
        </div>
    );
};

export default File;